























import { Vue, Prop, Component } from 'vue-property-decorator';
import { TextValuePair } from '@/models/TextValuePair';

@Component
export default class SingleSelectLink extends Vue {
    @Prop({ default: '' }) options!: string;
    @Prop() selectedvalue!: string;
    expanded: boolean = false;

    get selectedText(): string {
        if (this.selectedvalue === undefined || !this.options.length) {
            return '';
        }
        const text = this.parsedOptions.find((o: TextValuePair) => {
            return o.value === this.selectedvalue;
        });
        if (typeof text !== 'undefined') {
            return text.text;
        } else {
            return '';
        }
    }

    get parsedOptions(): TextValuePair[] {
        return JSON.parse(this.options) || [];
    }

    unexpand(e: FocusEvent) {
        if (e.relatedTarget == null || !this.$el.contains(e.relatedTarget as Node)) {
            this.expanded = false;
        }
    }

    expand() {
        if (this.options.length > 0) {
            this.expanded = !this.expanded;
        }
    }
}
